import type { ResourceReservation } from "@@/shared/acquire/resources/resource-reservation";

const parseLatestResourceReservationComment = (
    reservation: ResourceReservation,
) => {
    if (reservation.comments && reservation.comments.length > 0) {
        const latestComment = reservation.comments.sort(
            (a, b) => b._createdAt.unix - a._createdAt.unix,
        )[0];

        return latestComment.comment;
    }
    return undefined;
};

export { parseLatestResourceReservationComment };
